import { Skeleton } from '@mui/material';
import classNames from 'classnames';
import { CSSProperties } from 'react';
import css from './VideoSkeleton.module.scss';

type VideoSkeletonProps = {
  className?: string;
  style?: CSSProperties;
};

export const VideoSkeleton = ({ className, style }: VideoSkeletonProps) => (
  <Skeleton
    variant="rectangular"
    className={classNames(css.skeletonVideo, className)}
    style={style}
    animation="wave"
  />
);
